import React, { useEffect, useState } from "react";
import GetMonthsOpt from "../Dropdowns/getSelectMonth.js";
import GetYearsOpt from "../Dropdowns/getSelectYear.js";
import GetAllDistrictsAll from "../Dropdowns/getAllDistricts.jsx";
import VerifyCommissionNFSADetailsReport from "./VerifyCommissionNFSADetailsReport.jsx";
import axios from "axios";

const VerifyCommissionNFSAReport = () => {
  const [loading, setLoading] = useState(true);
  const [district, setDistrict] = useState("");
  const [userRole, setUserRole] = useState("");
  const [districts, setDistricts] = useState([]);
  const [distCode, setDistCode] = useState("0");
  const [userName, setUserName] = useState("");
  const [sessionExpired, setSessionExpired] = useState(false);
  const [sessionLoading, setSessionLoading] = useState(true);
  const [renderContent, setRenderContent] = useState(null);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_URL}/api/ekyc-abstract/session-info`, {
        withCredentials: true,
      })
      .then((res) => {
        setUserRole(res.data.userRole || "0");
        setUserName(res.data.loginUserName);
        setSessionExpired(false);
      })
      .catch(() => {
        setSessionExpired(true);
        setUserRole("0");
      })
      .finally(() => {
        setSessionLoading(false);
      });

      axios.get(`${process.env.REACT_APP_URL}/api/fps/districts`).then(res => {
          setDistricts(res.data);      
      });
  }, []);


 
  // Single loading handler
  const handleLoadingChange = (isLoading) => {
    setLoading(isLoading);
  };

  // Loading handler passthroughs
  const handleMonthsLoadingChange = handleLoadingChange;
  const handleYearsLoadingChange = handleLoadingChange;

  // District dropdown loading handler
  const setLoadingDistricts = (isLoading) => {
    setLoading(isLoading);
  };

  // District change handler
  const handleDistrictChange = (selectedCode) => {
    setDistCode(selectedCode);
    const match = districts.find((d) => d.dist_code === selectedCode);

    setDistrict(
      selectedCode === "0" || !selectedCode
        ? "ALL"
        : match
        ? match.dist_name_en
        : ""
    );
  };

    // useEffect(() => {
    //     if (userRole === "2" && userName && districts.length > 0) {
    //       // Find district where dist_name_en matches userName (case-insensitive)
    //       const matchedDistrict = districts.find(
    //         (d) => d.dist_name_en.toLowerCase() === userName.toLowerCase()
    //       );
    
    //       if (matchedDistrict) {
    //         setDistCode(matchedDistrict.dist_code);
    //         setDistrict(matchedDistrict.dist_name_en);
    //       } else {
    //         setDistCode("0");
    //         setDistrict("ALL");
    //       }
    //     }
    //   }, [userRole, userName, districts]);

     useEffect(() => {
  if (userRole !== "2" || !districts) return;

  const districtList = Array.isArray(districts) ? districts : [districts];

  if (districtList.length === 1) {
    const { dist_code, dist_name } = districtList[0];
    setDistCode(dist_code);
    setDistrict(dist_name);
  }
}, [userRole, districts]);

   const handleSubmit = async () => {
    const month = document.getElementById("month").value;
    const year = document.getElementById("year").value;
    const allot_month = document.getElementById("allot_month").value;
    const allot_year = document.getElementById("allot_year").value;
    const distMonthName =
      document.getElementById("month").options[
        document.getElementById("month").selectedIndex
      ].text;
    const alotMonthName =
      document.getElementById("allot_month").options[
        document.getElementById("allot_month").selectedIndex
      ].text;
    if (month == null || month == "") {
      alert("Please select Distribution Month");
      return false;
    } else if (year == null || year == "") {
      alert("Please select Distribution Year");
      return false;
    } else if (allot_month == null || allot_month == "") {
      alert("Please select Allotted Month");
      return false;
    } else if (allot_year == null || allot_year == "") {
      alert("Please select Allotted Year");
      return false;
    } else {
      setRenderContent(null);
      setRenderContent(
        <VerifyCommissionNFSADetailsReport
          month={month}
          year={year}
          allotMonth={allot_month}
          allotYear={allot_year}
          distCode={distCode}
          distMonthName={distMonthName}
          alotMonthName={alotMonthName}
          userRole={userRole}
        />
      );
    }
  };

  return (
    <div
      className="wrapper row3"
      style={{  paddingBottom: "40px" }}
    >
      <div id="container">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "10px",
          }}
        >
          <table width="55%">
            <thead>
              <tr className="tableheader">
                <th colSpan={14}>Monthly FPS Dealer Commission (NFSA)</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>Distribution Month :</td>
                <td>
                  <GetMonthsOpt
                    input_id="month"
                    onLoadingChange={handleMonthsLoadingChange}
                  />
                </td>

                <td>Distribution Year:</td>
                <td>
                  <GetYearsOpt
                    input_id="year"
                    onLoadingChange={handleYearsLoadingChange}
                  />
                </td>

                <td>Allotted Month :</td>
                <td>
                  <GetMonthsOpt
                    input_id="allot_month"
                    onLoadingChange={handleMonthsLoadingChange}
                  />
                </td>

                <td>Allotted Year:</td>
                <td>
                  <GetYearsOpt
                    input_id="allot_year"
                    onLoadingChange={handleYearsLoadingChange}
                  />
                </td>
                <td>
                  <b>District</b>
                </td>
                <td>
                  {userRole === "1" || userRole === "9" || userRole === "10"|| userRole === "22" ? (
                    <>
                      <GetAllDistrictsAll
                        onLoadingChange={setLoadingDistricts}
                        onChange={handleDistrictChange}
                      />
                    </>
                  ) : userRole === "2" ? (
                    <>
                      <input
                        type="hidden"
                        id="dist_code"
                        name="distCode"
                        value={distCode}
                      />
                      <div>{userName}</div>
                    </>
                  ) : (
                    <span>N/A</span>
                  )}
                </td>
              </tr>
              <tr>
                <td colSpan="14" align="center">
                  {
                    <button
                      className="button button2"
                      style={{ marginRight: "10px" }}
                      onClick={handleSubmit}
                    >
                      Submit
                    </button>
                  }
                  <button
                    className="button button2"
                    onClick={() => window.history.back()}
                  >
                    Back
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div id="loading" style={{ display: "none", textAlign: "center" }}>
          <img src="images/progress.gif" alt="Loading" />
        </div>
        <br />
        <div id="vefifyCommissionNfsaTdsPtax">{renderContent}</div>
      </div>
    </div>
  );
};

export default VerifyCommissionNFSAReport;
